// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"2d67c95f","397":"f245a616","455":"7d976083","977":"61d023c9"}[chunkId] + ".chunk.js";
};